import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { LinkButton, Button } from 'components/facade/button';
import { BodyShort01, ProductiveHeading05 } from 'components/styles';
export const Image = styled.div`
  width: ${(props)=>props.size === 'large' ? '422px' : props.size === 'middle' ? '80px' : 'auto'};
  height: ${(props)=>props.size === 'large' ? '264px' : props.size === 'middle' ? '80px' : 'auto'};
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Title = styled.div`
  ${ProductiveHeading05};
`;
const Message = styled.div`
  ${BodyShort01};
  width: 80%;
`;
const PrimaryCTA = styled(Button).attrs({
    type: 'primary',
    iconPlacement: 'right'
})``;
const SecondaryCTA = styled(LinkButton)`
  display: flex;
  align-items: center;
  text-align: left;
`;
export const Content = styled(Space)``;
const Info = Content;
const CTA = Content;
/* ${Title}, ${Message} {
    width: 80%;
  } */ export const Container = styled(Space)`
  width: 424px;
  max-width: 424px;
  ${(props)=>props.direction === 'horizontal' && `
      ${Content} {
        width: 100%;
        max-width: 100%;
      };

      ${props.size === 'large' && `
        ${Content} {
          width: 288px;
        };
      `}
    `};
`;
const StyledCallToAction = styled(Space).attrs({
    direction: 'vertical',
    size: 16
})``;
const CallToAction = StyledCallToAction;
CallToAction.Primary = PrimaryCTA;
CallToAction.Secondary = SecondaryCTA;
const EmptyStateComponent = (props)=>{
    const { className, image, title, message, primaryCTA, secondaryCTA, direction = 'vertical', size = 'middle', children, ...rest } = props;
    return /*#__PURE__*/ _jsxs(Container, {
        className: className,
        direction: direction,
        size: size,
        ...rest,
        children: [
            image && /*#__PURE__*/ _jsx(Image, {
                size: size,
                children: image
            }),
            /*#__PURE__*/ _jsxs(Content, {
                direction: "vertical",
                size: size === 'middle' && direction === 'horizontal' ? 8 : 24,
                children: [
                    (title || message) && /*#__PURE__*/ _jsxs(Info, {
                        direction: "vertical",
                        children: [
                            title && /*#__PURE__*/ _jsx(Title, {
                                children: title
                            }),
                            message && /*#__PURE__*/ _jsx(Message, {
                                children: message
                            })
                        ]
                    }),
                    (primaryCTA || secondaryCTA) && /*#__PURE__*/ _jsxs(CTA, {
                        direction: "vertical",
                        size: 16,
                        children: [
                            primaryCTA,
                            secondaryCTA
                        ]
                    })
                ]
            }),
            children
        ]
    });
};
const EmptyState = EmptyStateComponent;
EmptyState.Image = Image;
EmptyState.Title = Title;
EmptyState.Message = Message;
EmptyState.CallToAction = CallToAction;
const EmptyStateContainer = styled.div`
  background-color: ${(props)=>props.$transparent ? 'transparent' : 'var(--white-100)'};
  padding: 160px 128px;
  border-radius: ${(props)=>props.$isNew ? 'var(--border-radius-small)' : '0px'};
`;
export { EmptyState, EmptyStateContainer };
